/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { useOrgId } from '../provider';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_USER_LIST } from '../../api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { userListConfig } from '../../config/userLists.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};
export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    console.log(`args in user lists service`, args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_USER_LIST, {
          input: {
            where: args?.where ?? [],
            limit: args?.size,
            skip: args?.offset,
            order: [
              {
                column: 'createdAt',
                direction: 'DESC',
              },
            ],
            relationFilter: {
              role: {
                where: [
                  {
                    column: "name",
                    value: ["director","owner"],
                    op: "NotIn"
                  }
                ],
                limit: null,
                skip: null
              }
            }
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(res?.data?.getUserList?.data);
          console.log(`row data`, _rowData);
          if (_rowData) {
            return {
              ...userListConfig,
              ultUsers: _rowData ? _rowData : [],
              userRoles: res?.data?.getRoleList?.data,
              isEmpty: res?.data?.getUserList?.data?.length <= 0,
              // studentGroup: holderGroups,
              activePage: res?.data?.getUserList?.currentPage,
              pageSize: res?.data?.getUserList?.pageSize,
              totalCount: res?.data?.getUserList?.totalCount,
              totalPages: res?.data?.getUserList?.totalPages,
            };
          } else {
            return {
              isEmpty: true,
            };
          }
        } else {
          return {
            isEmpty: true,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatRole(role: any[]) {
    if (Array.isArray(role)) {
      return role
        ?.filter((item) => item)
        ?.map((item) => {
          let name = item?.name?.[0]?.toUpperCase(),
            img = item?.name?.[0];
          for (let i = 1; i < item?.name?.length; i++) {
            if (item?.name?.[i] == '_' || i === 0) {
              name += ' ' + item?.name?.[i + 1]?.toUpperCase();
              img += item?.name?.[i + 1];
              i++;
            } else name += item?.name?.[i];
          }
          return {
            ...item,
            name,
            img,
          };
        });
    }
    return [];
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.vuid,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus ?? item?.onboardingStatus, item?.suspended),
          name: `${toHeaderCase(item?.firstName ?? '')} ${toHeaderCase(
            item?.lastName ?? ''
          )}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          image: item?.image,
          verified: item?.emailVerified,
          role: this.formatRole(item?.role),
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    switch (status) {
      case 'TEMPORARILY_UNAVAILABLE':
        return 'Inactive';
      case 'INVITED':
        return 'invited';
      case 'ACTIVE':
        return 'active';
      case 'SUSPENDED':
        return 'suspended';
      case 'DEACTIVATED':
        return 'Deactivated';
        case 'USER_ADDED':
          return 'User Added';
        case 'USER_INVITED':
          return 'User Invited';
        case 'USER_VERIFIED':
          return 'User Verified';
        case 'USER_ACC_CREATED':
          return 'User Account Created';
        case 'USER_WALLET_REGISTERED':
          return 'User Wallet Registered';
      default:
        return '-';
    }
  }


}
